module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="u-spaceAround">\n    <div class="js-paginator-list blockGrid blockGrid-1 blockGrid-tablet2"></div>\n</div>\n';
}
return __p;
};
